<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="backPage">
                        <img src="@/assets/common/hd_prev_btn.png" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <p class="page_title">비밀번호 변경</p>
                <form action="#n" method="post" id="user_form">
                    <div class="input_wrap">
                        <div class="input_box input_verf_box">
                            <span class="ico"><img src="@/assets/user/form_ico2.png" alt="" /></span>
                            <div class="info_input_box">
                                <input type="password" v-model="state.password" name="" placeholder="비밀번호"
                                    @input="passwordCheck" autoComplete="off" />
                                <span class="input_info">대소문자+숫자+특수문자 8~15글자</span>
                            </div>
                        </div>
                        <p class="verf_txt fail" v-if="check.checkPetern" style="display: block">
                            올바른 비밀번호 형식이 아닙니다.
                        </p>
                        <div class="input_box input_verf_box">
                            <span class="ico"><img src="@/assets/user/form_ico2.png" alt="" /></span>
                            <input type="password" v-model="state.checkPassword" name="" placeholder="비밀번호 확인"
                                @input="pwCheck" autoComplete="off" />
                        </div>
                        <p class="verf_txt fail" v-if="check.samePassword" style="display: block">
                            비밀번호가 일치하지 않습니다.
                        </p>
                    </div>
                    <div class="mini_submit_btn">
                        <button type="button" id="submit_btn" @click="checkInput">변경</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :content="modal.content" :yes="modal.confirm" :no="modal.cancel"
        @close="modalClose">
    </ModalComponent>
</template>

<script lang="ts" config>
import {
    apiService,
    reactive,
    res,
    router,
    ModalComponent,
    useRoute,
    userStore,
    globalStore
} from "@/BaseComponent";

export default {
    props: {},
    components: { ModalComponent },
    setup() {
        const route = useRoute();
        const user = userStore();
        const global = globalStore();
        const state = reactive({
            password: "" as string,
            checkPassword: "" as string,
            applyCode: route.query.code as any,
            idx: route.query.idx as any,
            modalContent: "" as string,
            isModalOpen: false as boolean,
        });
        const check = reactive({
            samePassword: false as boolean,
            checkPetern: false as boolean,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        //비밀번호 확인
        const passwordCheck = () => {
            pwCheck();
            paternCheck();
        };

        const pwCheck = () => {
            if (state.password != state.checkPassword) {
                check.samePassword = true;
            } else if (state.checkPassword == state.password) {
                check.samePassword = false;
            }
        };

        const paternCheck = () => {
            const pattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/;
            if (!pattern.test(state.password)) {
                check.checkPetern = true;
            } else {
                check.checkPetern = false;
            }
        };

        const backPage = () => {
            router.back();
        };

        const changePassword = async () => {
            let res: res = await apiService.member.modifyPassword(state.password);
            if (res.returnCode === 0) {
                modal.content = "비밀번호가 변경되었습니다.<br>다시 로그인해주세요";
                state.isModalOpen = true;
                modal.confirm = "로그인하기";
                modal.cancel = "";
                modal.actionCode = 1;
            } else {
                console.error("비밀번호 변경오류", res.description);
                modal.content = res.description;
                state.isModalOpen = true;
                modal.confirm = "";
                modal.cancel = "확인";
            }
        };

        const checkInput = () => {
            if (state.password != "" && state.checkPassword != "") {
                if (check.checkPetern === false && check.samePassword === false) {
                    changePassword();
                } else {
                    modal.content = "비밀번호의 패턴, 비밀번호가 다릅니다.";
                    state.isModalOpen = true;
                    modal.confirm = "";
                    modal.cancel = "확인";
                }
            } else {
                modal.content = "비밀번호를 확인해주세요";
                state.isModalOpen = true;
                modal.confirm = "";
                modal.cancel = "확인";
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        user.setToken(null);
                        user.setInfo(null);
                        global.setSelectMenu("");
                        global.setChart("");
                        router.replace("/login");
                        break;

                    default:
                        break;
                }
            }
        };
        return {
            state,
            modal,
            check,
            router,
            pwCheck,
            passwordCheck,
            backPage,
            checkInput,
            modalClose,
        };
    },
};
</script>
